import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const CarouselGaleria = ({ images, onClose }: any) => {
  return (
    <div
      className="bg-black w-full h-full overflow-auto lg:flex justify-center py-[10px] lg:py-[70px]"
      style={{
        position: "absolute",
        top: "0px",
        zIndex: 51,
        left: "0px",
        right: "0px",
        border: "0px solid red",
      }}
    >
      <div
        className="py-6 px-3 fixed border w-full bg-black"
        style={{ zIndex: 2, top: 0 }}
      >
        <label
          className="cursor-pointer hover:bg-gray-20  border px-4 py-3  text-white font-bold"
          style={{ borderRadius: "10px" }}
        >
          X Cerrar
          <button className="hidden" onClick={() => onClose(false)}></button>
        </label>
      </div>

      <div className="w-full h-full ">
        <Carousel
          autoPlay={false}
          //centerMode={true}
          dynamicHeight={true}
          infiniteLoop={true}
          showArrows={true}
          showStatus={false}
          showIndicators={true}
          showThumbs={true}
        >
          {images.map((img: any, index: any) => {
            return (
              <div className="lg:h-[600px] lg:w-[600px] lg:px-[20] mx-auto">
                <img
                  src={img.url}
                  alt=""
                  key={index}
                  style={{
                    objectFit: "cover",
                  }}
                  className="bg-gray-30 w-full h-full"
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default CarouselGaleria;
